var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggleLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.828125 8.24902C1.16992 8.24902 1.43359 7.99023 1.43359 7.64844V4.44043C1.44824 4.59668 1.5166 4.74805 1.62891 4.85547L4.82715 8.05371C4.96387 8.18555 5.11523 8.24902 5.28125 8.24902C5.63281 8.24902 5.88672 7.99023 5.88672 7.65332C5.88672 7.46777 5.80859 7.31641 5.69141 7.2041L4.58789 6.0957L3.32324 4.97754L4.38281 5.02148H10.1055C10.4863 5.02148 10.75 4.76758 10.75 4.39648C10.75 4.02051 10.4863 3.7666 10.1055 3.7666H4.38281L3.32324 3.81055L4.58789 2.69727L5.69141 1.5791C5.80859 1.4668 5.88672 1.31543 5.88672 1.13477C5.88672 0.792969 5.63281 0.539062 5.28125 0.539062C5.11523 0.539062 4.96387 0.602539 4.82715 0.734375L1.62891 3.93262C1.5166 4.04004 1.44824 4.19141 1.43359 4.34766V1.14453C1.43359 0.797852 1.16992 0.539062 0.828125 0.539062C0.481445 0.539062 0.217773 0.797852 0.217773 1.14453V7.64844C0.217773 7.99023 0.481445 8.24902 0.828125 8.24902Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleLeft);
export default __webpack_public_path__ + "static/media/toggle-left.ed7cc2df5a24f0acda21be4c2e4ea7c5.svg";
export { ForwardRef as ReactComponent };